export default {
    brush: {
        title: 'Harja',
        brushHardness: 'Siveltimen kovuus',
        brushSize: 'Siveltimen koko',
        brushColor: 'Siveltimen väri',
    },
};
